var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultsDesktopGe(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7409.35 3594.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:lime;}.cls-2{fill:#ccc;}.cls-3{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grey"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "664.67 1603.48 664.67 1645.2 516.72 1645.2 516.72 496.23 1700.34 496.23 1700.34 569.21 1737.33 569.21 1737.33 606.2 1772.05 606.2 1772.05 1603.48 664.67 1603.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2778.27 1604.53 2778.27 1646.25 2223.44 1646.25 2223.44 497.28 3333.09 497.28 3333.09 681.22 3444.05 681.22 3444.05 718.21 3478.77 718.21 3478.77 1604.53 2778.27 1604.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5079.51 1571.6 5079.51 1604.5 3932.87 1604.5 3932.87 498.17 5153.48 498.17 5153.48 534.16 5188.2 534.16 5188.2 1571.6 5079.51 1571.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6228.79 1644.51 6228.79 1679.23 5635.97 1679.23 5635.97 496.89 6745.62 496.89 6745.62 643.83 6782.58 643.83 6782.58 680.82 6891.3 680.82 6891.3 1644.51 6228.79 1644.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1413.12 3282.12 1413.12 3315.03 525.48 3315.03 525.48 2208.69 1672.09 2208.7 1672.09 2281.68 1708.61 2281.17 1709.1 2317.69 1780.81 2317.69 1780.81 3282.12 1413.12 3282.12"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1738.08 526.22 1774.3 526.22 1774.3 563.21 1810.53 563.21 1810.53 453.24 1738.08 453.24 1738.08 526.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3382.5 637.25 3493.47 637.25 3493.47 674.24 3528.18 674.24 3528.18 453.3 3382.5 453.3 3382.5 637.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6790.77 604.84 6827.73 604.84 6827.73 640.83 6936.45 640.83 6936.45 457.9 6790.77 457.9 6790.77 604.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1752.76 2279.17 1752.76 2241.68 1715.78 2241.68 1715.78 2169.2 1824.47 2169.2 1824.47 2279.17 1752.76 2279.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5188.2,
    y: 462.19,
    width: 34.72,
    height: 35.99
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1737.33,
    y1: 569.21,
    x2: 1737.33,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1700.34,
    y1: 496.23,
    x2: 1700.34,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1663.35,
    y1: 496.23,
    x2: 1663.35,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1626.36,
    y1: 496.23,
    x2: 1626.37,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1589.38,
    y1: 496.23,
    x2: 1589.38,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1552.39,
    y1: 496.23,
    x2: 1552.39,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1515.4,
    y1: 496.23,
    x2: 1515.4,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1478.41,
    y1: 496.23,
    x2: 1478.41,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1441.42,
    y1: 496.23,
    x2: 1441.43,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1404.44,
    y1: 496.23,
    x2: 1404.44,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1367.45,
    y1: 496.23,
    x2: 1367.45,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1330.46,
    y1: 496.23,
    x2: 1330.46,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1293.47,
    y1: 496.23,
    x2: 1293.47,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1256.48,
    y1: 496.23,
    x2: 1256.49,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1219.49,
    y1: 496.23,
    x2: 1219.5,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1182.51,
    y1: 496.23,
    x2: 1182.51,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1145.52,
    y1: 496.23,
    x2: 1145.52,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1108.53,
    y1: 496.23,
    x2: 1108.53,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1071.54,
    y1: 496.23,
    x2: 1071.54,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1034.55,
    y1: 496.23,
    x2: 1034.56,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 997.57,
    y1: 496.23,
    x2: 997.57,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 960.58,
    y1: 496.23,
    x2: 960.58,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 923.59,
    y1: 496.23,
    x2: 923.59,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 886.6,
    y1: 496.23,
    x2: 886.6,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 849.61,
    y1: 496.23,
    x2: 849.62,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 812.62,
    y1: 496.23,
    x2: 812.63,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 775.64,
    y1: 496.23,
    x2: 775.64,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 738.65,
    y1: 496.23,
    x2: 738.65,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 701.66,
    y1: 496.23,
    x2: 701.66,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 664.67,
    y1: 496.23,
    x2: 664.67,
    y2: 1602.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 627.68,
    y1: 496.23,
    x2: 627.69,
    y2: 1645.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 590.7,
    y1: 496.23,
    x2: 590.7,
    y2: 1645.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 553.71,
    y1: 496.23,
    x2: 553.71,
    y2: 1645.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 532.22,
    x2: 1700.34,
    y2: 532.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 569.21,
    x2: 1772.05,
    y2: 569.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 606.2,
    x2: 1772.05,
    y2: 606.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 643.18,
    x2: 1772.05,
    y2: 643.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 680.17,
    x2: 1772.05,
    y2: 680.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 717.16,
    x2: 1772.05,
    y2: 717.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 754.15,
    x2: 1772.05,
    y2: 754.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 791.14,
    x2: 1772.05,
    y2: 791.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 828.13,
    x2: 1772.05,
    y2: 828.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 865.11,
    x2: 1772.05,
    y2: 865.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 902.1,
    x2: 1772.05,
    y2: 902.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 939.09,
    x2: 1772.05,
    y2: 939.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 976.08,
    x2: 1772.05,
    y2: 976.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1013.07,
    x2: 1772.05,
    y2: 1013.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1050.05,
    x2: 1772.05,
    y2: 1050.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1087.04,
    x2: 1772.05,
    y2: 1087.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1124.03,
    x2: 1772.05,
    y2: 1124.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1161.02,
    x2: 1772.05,
    y2: 1161.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1198.01,
    x2: 1772.05,
    y2: 1198.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1235,
    x2: 1772.05,
    y2: 1235
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1271.98,
    x2: 1772.05,
    y2: 1271.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1308.97,
    x2: 1772.05,
    y2: 1308.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1345.96,
    x2: 1772.05,
    y2: 1345.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1382.95,
    x2: 1772.05,
    y2: 1382.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1419.94,
    x2: 1772.05,
    y2: 1419.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1456.92,
    x2: 1772.05,
    y2: 1456.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1493.91,
    x2: 1772.05,
    y2: 1493.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1530.9,
    x2: 1772.05,
    y2: 1530.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1567.89,
    x2: 1772.05,
    y2: 1567.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 516.72,
    y1: 1604.88,
    x2: 1772.05,
    y2: 1604.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1737.33,
    y1: 489.43,
    x2: 1810.53,
    y2: 489.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1774.32,
    y1: 452.83,
    x2: 1774.32,
    y2: 526.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1737.7,
    y1: 525.56,
    x2: 1810.9,
    y2: 525.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3444.05,
    y1: 681.22,
    x2: 3444.06,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3407.07,
    y1: 681.22,
    x2: 3407.07,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3370.08,
    y1: 681.22,
    x2: 3370.08,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3333.09,
    y1: 497.28,
    x2: 3333.09,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3296.1,
    y1: 497.28,
    x2: 3296.1,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3259.11,
    y1: 497.28,
    x2: 3259.12,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3222.12,
    y1: 497.28,
    x2: 3222.13,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3185.14,
    y1: 497.28,
    x2: 3185.14,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3148.15,
    y1: 497.28,
    x2: 3148.15,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3111.16,
    y1: 497.28,
    x2: 3111.16,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3074.17,
    y1: 497.28,
    x2: 3074.17,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3037.18,
    y1: 497.28,
    x2: 3037.19,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3000.2,
    y1: 497.28,
    x2: 3000.2,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2963.21,
    y1: 497.28,
    x2: 2963.21,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2926.22,
    y1: 497.28,
    x2: 2926.22,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2889.23,
    y1: 497.28,
    x2: 2889.23,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2852.24,
    y1: 497.28,
    x2: 2852.25,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2815.25,
    y1: 497.28,
    x2: 2815.26,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2778.27,
    y1: 497.28,
    x2: 2778.27,
    y2: 1603.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2741.28,
    y1: 497.28,
    x2: 2741.28,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2704.29,
    y1: 497.28,
    x2: 2704.29,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2667.3,
    y1: 497.28,
    x2: 2667.3,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2630.31,
    y1: 497.28,
    x2: 2630.32,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2593.33,
    y1: 497.28,
    x2: 2593.33,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2556.34,
    y1: 497.28,
    x2: 2556.34,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2519.35,
    y1: 497.28,
    x2: 2519.35,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2482.36,
    y1: 497.28,
    x2: 2482.36,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2445.37,
    y1: 497.28,
    x2: 2445.38,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2408.39,
    y1: 497.28,
    x2: 2408.39,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2371.4,
    y1: 497.28,
    x2: 2371.4,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2334.41,
    y1: 497.28,
    x2: 2334.41,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2297.42,
    y1: 497.28,
    x2: 2297.42,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2260.43,
    y1: 497.28,
    x2: 2260.44,
    y2: 1646.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 533.27,
    x2: 3335.93,
    y2: 533.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 570.26,
    x2: 3333.09,
    y2: 570.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 607.25,
    x2: 3333.09,
    y2: 607.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 644.24,
    x2: 3333.09,
    y2: 644.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 681.22,
    x2: 3444.05,
    y2: 681.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 718.21,
    x2: 3478.77,
    y2: 718.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 755.2,
    x2: 3478.77,
    y2: 755.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 792.19,
    x2: 3478.77,
    y2: 792.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 829.18,
    x2: 3478.77,
    y2: 829.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 866.16,
    x2: 3478.77,
    y2: 866.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 903.15,
    x2: 3478.77,
    y2: 903.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 940.14,
    x2: 3478.77,
    y2: 940.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 977.13,
    x2: 3478.77,
    y2: 977.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1014.12,
    x2: 3478.77,
    y2: 1014.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1051.11,
    x2: 3478.77,
    y2: 1051.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1088.09,
    x2: 3478.77,
    y2: 1088.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1125.08,
    x2: 3478.77,
    y2: 1125.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1162.07,
    x2: 3478.77,
    y2: 1162.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1199.06,
    x2: 3478.77,
    y2: 1199.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1236.05,
    x2: 3478.77,
    y2: 1236.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1273.03,
    x2: 3478.77,
    y2: 1273.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1310.02,
    x2: 3478.77,
    y2: 1310.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1347.01,
    x2: 3478.77,
    y2: 1347.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1384,
    x2: 3478.77,
    y2: 1384
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1420.99,
    x2: 3478.77,
    y2: 1420.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1457.97,
    x2: 3478.77,
    y2: 1457.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1494.96,
    x2: 3478.77,
    y2: 1494.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1531.95,
    x2: 3478.77,
    y2: 1531.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1568.94,
    x2: 3478.77,
    y2: 1568.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2223.45,
    y1: 1605.93,
    x2: 3478.77,
    y2: 1605.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3380.07,
    y1: 489.9,
    x2: 3528.44,
    y2: 489.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3419.49,
    y1: 453.3,
    x2: 3419.49,
    y2: 637.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3455.34,
    y1: 453.3,
    x2: 3455.34,
    y2: 637.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3491.5,
    y1: 453.3,
    x2: 3491.5,
    y2: 637.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3380.44,
    y1: 526.03,
    x2: 3528.18,
    y2: 526.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3380.07,
    y1: 563.77,
    x2: 3527.81,
    y2: 563.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3380.82,
    y1: 600.9,
    x2: 3528.56,
    y2: 600.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3382.07,
    y1: 638.02,
    x2: 3529.81,
    y2: 638.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5153.48,
    y1: 534.16,
    x2: 5153.49,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5116.5,
    y1: 498.17,
    x2: 5116.5,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5079.51,
    y1: 498.17,
    x2: 5079.51,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5042.52,
    y1: 498.17,
    x2: 5042.52,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5005.53,
    y1: 498.17,
    x2: 5005.53,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4968.54,
    y1: 498.17,
    x2: 4968.55,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4931.55,
    y1: 498.17,
    x2: 4931.56,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4894.57,
    y1: 498.17,
    x2: 4894.57,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4857.58,
    y1: 498.17,
    x2: 4857.58,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4820.59,
    y1: 498.17,
    x2: 4820.59,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4783.6,
    y1: 498.17,
    x2: 4783.6,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4746.61,
    y1: 498.17,
    x2: 4746.62,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4709.63,
    y1: 498.17,
    x2: 4709.63,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4672.64,
    y1: 498.17,
    x2: 4672.64,
    y2: 1604.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4635.65,
    y1: 498.17,
    x2: 4635.65,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4598.66,
    y1: 498.17,
    x2: 4598.66,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4561.67,
    y1: 498.17,
    x2: 4561.68,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4524.68,
    y1: 498.17,
    x2: 4524.69,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4487.7,
    y1: 498.17,
    x2: 4487.7,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4450.71,
    y1: 498.17,
    x2: 4450.71,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4413.72,
    y1: 498.17,
    x2: 4413.72,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4376.73,
    y1: 498.17,
    x2: 4376.73,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4339.74,
    y1: 498.17,
    x2: 4339.75,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4302.76,
    y1: 498.17,
    x2: 4302.76,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4265.77,
    y1: 498.17,
    x2: 4265.77,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4228.78,
    y1: 498.17,
    x2: 4228.78,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4191.79,
    y1: 498.17,
    x2: 4191.79,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4154.8,
    y1: 498.17,
    x2: 4154.81,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4117.81,
    y1: 498.17,
    x2: 4117.82,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4080.83,
    y1: 498.17,
    x2: 4080.83,
    y2: 1604.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4043.84,
    y1: 498.17,
    x2: 4043.84,
    y2: 1647.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4006.85,
    y1: 498.17,
    x2: 4006.85,
    y2: 1647.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3969.86,
    y1: 498.17,
    x2: 3969.86,
    y2: 1647.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 534.16,
    x2: 5153.48,
    y2: 534.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 571.15,
    x2: 5188.2,
    y2: 571.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 608.14,
    x2: 5188.2,
    y2: 608.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 645.13,
    x2: 5188.2,
    y2: 645.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 682.11,
    x2: 5188.2,
    y2: 682.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 719.1,
    x2: 5188.2,
    y2: 719.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 756.09,
    x2: 5188.2,
    y2: 756.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 793.08,
    x2: 5188.2,
    y2: 793.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 830.07,
    x2: 5188.2,
    y2: 830.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 867.06,
    x2: 5188.2,
    y2: 867.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 904.04,
    x2: 5188.2,
    y2: 904.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 941.03,
    x2: 5188.2,
    y2: 941.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 978.02,
    x2: 5188.2,
    y2: 978.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1015.01,
    x2: 5188.2,
    y2: 1015.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1052,
    x2: 5188.2,
    y2: 1052
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1088.98,
    x2: 5188.2,
    y2: 1088.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1125.97,
    x2: 5188.2,
    y2: 1125.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1162.96,
    x2: 5188.2,
    y2: 1162.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1199.95,
    x2: 5188.2,
    y2: 1199.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1236.94,
    x2: 5188.2,
    y2: 1236.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1273.92,
    x2: 5188.2,
    y2: 1273.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1310.91,
    x2: 5188.2,
    y2: 1310.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1347.9,
    x2: 5188.2,
    y2: 1347.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1384.89,
    x2: 5188.2,
    y2: 1384.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1421.88,
    x2: 5188.2,
    y2: 1421.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1458.87,
    x2: 5188.2,
    y2: 1458.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1495.85,
    x2: 5188.2,
    y2: 1495.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1532.84,
    x2: 5188.2,
    y2: 1532.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3932.88,
    y1: 1569.83,
    x2: 5188.2,
    y2: 1569.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6856.58,
    y1: 682.59,
    x2: 6856.58,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6819.59,
    y1: 682.59,
    x2: 6819.59,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6782.6,
    y1: 682.59,
    x2: 6782.61,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6745.61,
    y1: 496.89,
    x2: 6745.62,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6708.63,
    y1: 496.89,
    x2: 6708.63,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6671.64,
    y1: 496.89,
    x2: 6671.64,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6634.65,
    y1: 496.89,
    x2: 6634.65,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6597.66,
    y1: 496.89,
    x2: 6597.66,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6560.67,
    y1: 496.89,
    x2: 6560.68,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6523.69,
    y1: 496.89,
    x2: 6523.69,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6486.7,
    y1: 496.89,
    x2: 6486.7,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6449.71,
    y1: 496.89,
    x2: 6449.71,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6412.72,
    y1: 496.89,
    x2: 6412.72,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6375.73,
    y1: 496.89,
    x2: 6375.74,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6338.75,
    y1: 496.89,
    x2: 6338.75,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6301.76,
    y1: 496.89,
    x2: 6301.76,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6264.77,
    y1: 496.89,
    x2: 6264.77,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6227.78,
    y1: 496.89,
    x2: 6227.78,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6190.79,
    y1: 496.89,
    x2: 6190.79,
    y2: 1681.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6153.8,
    y1: 496.89,
    x2: 6153.81,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6116.82,
    y1: 496.89,
    x2: 6116.82,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6079.83,
    y1: 496.89,
    x2: 6079.83,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6042.84,
    y1: 496.89,
    x2: 6042.84,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6005.85,
    y1: 496.89,
    x2: 6005.85,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5968.86,
    y1: 496.89,
    x2: 5968.87,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5931.88,
    y1: 496.89,
    x2: 5931.88,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5894.89,
    y1: 496.89,
    x2: 5894.89,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5857.9,
    y1: 496.89,
    x2: 5857.9,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5820.91,
    y1: 496.89,
    x2: 5820.91,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5783.92,
    y1: 496.89,
    x2: 5783.93,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5746.93,
    y1: 496.89,
    x2: 5746.94,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5709.95,
    y1: 496.89,
    x2: 5709.95,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5672.96,
    y1: 496.89,
    x2: 5672.96,
    y2: 1691.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 532.88,
    x2: 6748.45,
    y2: 532.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 569.87,
    x2: 6745.61,
    y2: 569.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 606.86,
    x2: 6745.61,
    y2: 606.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 643.84,
    x2: 6745.61,
    y2: 643.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 680.83,
    x2: 6895.58,
    y2: 680.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 717.82,
    x2: 6891.3,
    y2: 717.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 754.81,
    x2: 6891.3,
    y2: 754.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 791.8,
    x2: 6891.3,
    y2: 791.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 828.78,
    x2: 6891.3,
    y2: 828.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 865.77,
    x2: 6891.3,
    y2: 865.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 902.76,
    x2: 6891.3,
    y2: 902.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 939.75,
    x2: 6891.3,
    y2: 939.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 976.74,
    x2: 6891.3,
    y2: 976.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1013.73,
    x2: 6891.3,
    y2: 1013.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1050.71,
    x2: 6891.3,
    y2: 1050.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1087.7,
    x2: 6891.3,
    y2: 1087.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1124.69,
    x2: 6891.3,
    y2: 1124.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1161.68,
    x2: 6891.3,
    y2: 1161.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1198.67,
    x2: 6891.3,
    y2: 1198.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1235.65,
    x2: 6891.3,
    y2: 1235.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1272.64,
    x2: 6891.3,
    y2: 1272.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1309.63,
    x2: 6891.3,
    y2: 1309.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1346.62,
    x2: 6891.3,
    y2: 1346.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1383.61,
    x2: 6891.3,
    y2: 1383.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1420.6,
    x2: 6891.3,
    y2: 1420.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1457.58,
    x2: 6891.3,
    y2: 1457.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1494.57,
    x2: 6891.3,
    y2: 1494.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1531.56,
    x2: 6891.3,
    y2: 1531.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1568.55,
    x2: 6891.3,
    y2: 1568.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5635.97,
    y1: 1605.54,
    x2: 6891.3,
    y2: 1605.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5637.11,
    y1: 1643.86,
    x2: 6891.3,
    y2: 1643.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6788.34,
    y1: 494.5,
    x2: 6936.71,
    y2: 494.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6827.75,
    y1: 457.9,
    x2: 6827.75,
    y2: 641.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6863.61,
    y1: 457.9,
    x2: 6863.61,
    y2: 641.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6899.77,
    y1: 457.9,
    x2: 6899.77,
    y2: 641.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6788.71,
    y1: 530.62,
    x2: 6936.45,
    y2: 530.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6788.34,
    y1: 568.36,
    x2: 6936.08,
    y2: 568.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 6789.08,
    y1: 605.49,
    x2: 6936.82,
    y2: 605.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1746.09,
    y1: 2318.66,
    x2: 1746.1,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1709.1,
    y1: 2281.68,
    x2: 1709.11,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1672.12,
    y1: 2208.7,
    x2: 1672.12,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1635.13,
    y1: 2208.7,
    x2: 1635.13,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1598.14,
    y1: 2208.7,
    x2: 1598.14,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1561.15,
    y1: 2208.7,
    x2: 1561.15,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1524.16,
    y1: 2208.7,
    x2: 1524.17,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1487.18,
    y1: 2208.7,
    x2: 1487.18,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1450.19,
    y1: 2208.7,
    x2: 1450.19,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1413.2,
    y1: 2208.7,
    x2: 1413.2,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1376.21,
    y1: 2208.7,
    x2: 1376.21,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1339.22,
    y1: 2208.7,
    x2: 1339.23,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1302.23,
    y1: 2208.7,
    x2: 1302.24,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1265.25,
    y1: 2208.7,
    x2: 1265.25,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1228.26,
    y1: 2208.7,
    x2: 1228.26,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1191.27,
    y1: 2208.7,
    x2: 1191.27,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1154.28,
    y1: 2208.7,
    x2: 1154.28,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1117.29,
    y1: 2208.7,
    x2: 1117.3,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1080.31,
    y1: 2208.7,
    x2: 1080.31,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1043.32,
    y1: 2208.7,
    x2: 1043.32,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1006.33,
    y1: 2208.7,
    x2: 1006.33,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 969.34,
    y1: 2208.7,
    x2: 969.34,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 932.35,
    y1: 2208.7,
    x2: 932.36,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 895.36,
    y1: 2208.7,
    x2: 895.37,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 858.38,
    y1: 2208.7,
    x2: 858.38,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 821.39,
    y1: 2208.7,
    x2: 821.39,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 784.4,
    y1: 2208.7,
    x2: 784.4,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 747.41,
    y1: 2208.7,
    x2: 747.41,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 710.42,
    y1: 2208.7,
    x2: 710.43,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 673.44,
    y1: 2208.7,
    x2: 673.44,
    y2: 3315.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 636.45,
    y1: 2208.7,
    x2: 636.45,
    y2: 3357.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 599.46,
    y1: 2208.7,
    x2: 599.46,
    y2: 3357.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 562.47,
    y1: 2208.7,
    x2: 562.47,
    y2: 3357.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2244.69,
    x2: 1676.37,
    y2: 2244.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2281.68,
    x2: 1709.1,
    y2: 2281.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2318.66,
    x2: 1780.81,
    y2: 2318.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2355.65,
    x2: 1780.81,
    y2: 2355.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2392.64,
    x2: 1780.81,
    y2: 2392.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2429.63,
    x2: 1780.81,
    y2: 2429.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2466.62,
    x2: 1780.81,
    y2: 2466.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2503.6,
    x2: 1780.81,
    y2: 2503.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2540.59,
    x2: 1780.81,
    y2: 2540.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2577.58,
    x2: 1780.81,
    y2: 2577.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2614.57,
    x2: 1780.81,
    y2: 2614.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2651.56,
    x2: 1780.81,
    y2: 2651.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2688.55,
    x2: 1780.81,
    y2: 2688.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2725.53,
    x2: 1780.81,
    y2: 2725.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2762.52,
    x2: 1780.81,
    y2: 2762.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2799.51,
    x2: 1780.81,
    y2: 2799.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2836.5,
    x2: 1780.81,
    y2: 2836.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2873.49,
    x2: 1780.81,
    y2: 2873.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2910.47,
    x2: 1780.81,
    y2: 2910.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2947.46,
    x2: 1780.81,
    y2: 2947.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 2984.45,
    x2: 1780.81,
    y2: 2984.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 3021.44,
    x2: 1780.81,
    y2: 3021.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 3058.43,
    x2: 1780.81,
    y2: 3058.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 3095.42,
    x2: 1780.81,
    y2: 3095.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 3132.4,
    x2: 1780.81,
    y2: 3132.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 3169.39,
    x2: 1780.81,
    y2: 3169.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 3206.38,
    x2: 1780.81,
    y2: 3206.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 3243.37,
    x2: 1780.81,
    y2: 3243.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.49,
    y1: 3280.36,
    x2: 1780.81,
    y2: 3280.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1752.76,
    y1: 2279.17,
    x2: 1752.76,
    y2: 2169.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1790.17,
    y1: 2279.17,
    x2: 1790.17,
    y2: 2169.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1715.14,
    y1: 2241.27,
    x2: 1825.11,
    y2: 2241.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1715.14,
    y1: 2205.13,
    x2: 1825.11,
    y2: 2205.13
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsDesktopGe);
export default __webpack_public_path__ + "static/media/results-desktop-ge.08dbcea06e17b39f5db582be83eaca78.svg";
export { ForwardRef as ReactComponent };